import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import FormPersonal from "../formularios/FormPersonal";
import VistaPersonal from "../vistas/VistaPersonal";
// jquery
import $ from "jquery";
// Contexto
import { ModalContext } from "../../../../context/modalContext";
import { AlertBoxContext } from "../../../../context/alertBoxContext";
import { personal } from "../../../../contexto";
// Spinner
import CustomSpinner from "../../../generic/CustomSpinner";

const Personal = ({ idProvincia, idMision, categoriaMision }) => {
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos del personal de la misión
  const [datosPersonal, setDatosPersonal] = useState({});
  // Función para determinar que array de tipos de personal obtendremos en función de la obra

  useEffect(() => {
    handleGetDatosPersonal();
  }, []);

  // Obtiene los datos del personal de la misión
  const getDatosPersonal = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/personal`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos del personal de una misión
  const postDatosPersonal = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/personal`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos del personal de la misión
  const handleGetDatosPersonal = () => {
    setLoading(true);
    getDatosPersonal()
      .then((response) => {
        setLoading(false);
        setDatosPersonal(processDatosPersonal(response.items));
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejador para enviar los datos del personal de la misión
  const handlePostDatosPersonal = (data) => {
    modalSetShow(false);
    setLoading(true);
    Promise.all(
      Object.keys(personal[categoriaMision]).map((obraPersonal) => {
        // Si existe hacemos la petición
        if (obraPersonal in data) return postDatosPersonal(data[obraPersonal]);
      })
    )
      .then(() => {
        setLoading(false);
        // Volvemos a pedir los datos personal (TODO deberiamos crear función que actualice el estado)
        handleGetDatosPersonal();
        addAlert("Exito", "Se han editado los datos del personal que atiende la obra", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejamos con la siguiente función los datos personal para poder acceder a ellos como objeto cuya clave sea el tipo
  const processDatosPersonal = (misDatosPersonal) => {
    let returnDatosPersonal = {};
    // Recorremos y rellenamos con los que devuelve la petición
    for (let tipoDatoPersonal of misDatosPersonal) {
      returnDatosPersonal[tipoDatoPersonal.type] = tipoDatoPersonal;
    }

    return returnDatosPersonal;
  };

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Personal que atiende la obra
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar personal que atiende la obra");
                modalSetContent(<FormPersonal defaultValues={datosPersonal} objObrasPersonal={personal[categoriaMision]} submissionHandler={handlePostDatosPersonal} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaPersonal datosPersonal={datosPersonal} objObrasPersonal={personal[categoriaMision]} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Personal;
